import { Box, TableCell, Typography } from "@mui/material";
import { styled } from "@mui/system";

type EntriesTableCellProps = {
  noBorder?: boolean;
  borderLeft?: boolean;
  verticalAlign?: "top" | "middle";
};
export const EntriesTableCell = styled(TableCell, {
  shouldForwardProp: (prop) =>
    prop !== "noBorder" && prop !== "borderLeft" && prop !== "verticalAlign",
})<EntriesTableCellProps>(
  ({ noBorder, borderLeft, verticalAlign = "top" }) => ({
    borderRight: noBorder ? "none" : "1px solid rgba(224, 224, 224, 1)",
    borderLeft: noBorder
      ? "none"
      : borderLeft
        ? "1px solid rgba(224, 224, 224, 1)"
        : "none",
    borderBottom: "none",
    padding: "0.5rem",
    verticalAlign: verticalAlign,
  }),
);

export const CustomEntriesTableCell = styled(TableCell, {
  shouldForwardProp: (prop) =>
    prop !== "noBorder" &&
    prop !== "borderLeft" &&
    prop !== "verticalAlign" &&
    prop !== "width", // Allow width prop to be forwarded
})<EntriesTableCellProps>(
  ({ noBorder, borderLeft, verticalAlign = "top", width }) => ({
    borderRight: noBorder ? "none" : "1px solid rgba(224, 224, 224, 1)",
    borderLeft: noBorder
      ? "none"
      : borderLeft
        ? "1px solid rgba(224, 224, 224, 1)"
        : "none",
    borderBottom: "none",
    padding: "0.5rem",
    verticalAlign: verticalAlign,
    width: width ? `${width}px` : "auto", // Set width if provided, otherwise, set it to "auto"
    minWidth: width ? `${width}px` : "auto", // Set minWidth if provided, otherwise, set it to "auto"
  }),
);

export const RoundTextContainer = styled(Typography)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  margin: "auto",
  borderRadius: "100%",
  backgroundColor: "#A273E1",
  color: "#fff",
  width: "24px",
  height: "24px",
  fontWeight: 600,
  fontSize: "12px",
}));

export const PrimaryLightTextBox = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  gap: "0.5rem",
  color: "#7A4CC3", // primary.light in theme
  backgroundColor: "#4A1D9C0A",
  width: "fit-content",
}));

export const BottomActionBarContainer = styled(Box)(() => ({
  display: "flex",
  gap: "8px",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "0 1rem",
  width: "100%",
  height: "68px",
  position: "sticky",
  bottom: 0,
  boxSizing: "border-box",
  backgroundColor: "#fff",
  boxShadow:
    "0px 3px 3px -2px rgba(0, 0, 0, 0.2), 0px 3px 4px rgba(0, 0, 0, 0.14), 0px 1px 8px rgba(0, 0, 0, 0.12)",
}));

export const EntriesGroupLabel = styled(Typography)(() => ({
  textTransform: "uppercase",
  fontWeight: "bold",
  fontSize: "14px",
}));
